import { CheckCircle2, AlertTriangle, XCircle, CircleDashed } from "lucide-react";

const MAP = {
  GOOD: { icon: CheckCircle2, text: "GOOD", sub: "Offer meets your target margin" },
  MARGINAL: { icon: AlertTriangle, text: "MARGINAL", sub: "Profitable, below target margin" },
  LOSING: { icon: XCircle, text: "LOSING", sub: "Offer doesn't cover true cost" },
};

export const StatusBadge = ({ status, compact = false, testId = "status-badge" }) => {
  const m = MAP[status] || { icon: CircleDashed, text: "ENTER LOAD", sub: "Fill offer & miles to evaluate" };
  const Icon = m.icon;
  return (
    <div className={`status status-${(status || "none").toLowerCase()} ${compact ? "compact" : ""}`} data-testid={testId} data-status={status || "NONE"}>
      <Icon size={compact ? 18 : 30} strokeWidth={2.5} />
      <div>
        <div className="status-text">{m.text}</div>
        {!compact && <div className="status-sub">{m.sub}</div>}
      </div>
    </div>
  );
};

export const StatusChip = ({ status, testId }) => (
  <span className={`chip-status status-${status.toLowerCase()}`} data-testid={testId}>{status}</span>
);
